var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4983 7.00033C11.4983 8.38104 10.379 9.50033 8.99833 9.50033C7.61762 9.50033 6.49833 8.38104 6.49833 7.00033C6.49833 5.61961 7.61762 4.50033 8.99833 4.50033C10.379 4.50033 11.4983 5.61961 11.4983 7.00033Z",
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04688 7.0003C2.10877 3.61939 5.26734 1.16699 8.9987 1.16699C12.7301 1.16699 15.8887 3.61942 16.9505 7.00036C15.8886 10.3813 12.7301 12.8337 8.99872 12.8337C5.26734 12.8337 2.10875 10.3812 1.04688 7.0003Z",
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7fc285b24f4d831367fdad136316e301.svg";
export { ForwardRef as ReactComponent };